import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import MolGrid from "../../components/Grid/MolGrid";
import { CriteriaApprovalData } from "./data/CriteriaApprovalData";
import { CriteriaApprovalConfig } from "./data/CriteriaApprovalConfig";
import { useGetAllCriteriaListForApprovalMutation, useGetAllCriteriaListMutation, useLazyGetAllDropdownForCRUDCategoryQuery } from "../../app/services/Crud/crudApi";
import { setAllDropDownField } from "./utils/dropdownUtils";
import { encryptAESID } from "../../utils/Encryption";
const DEFAULT_PAGINATION = {
  pageNo: 1,
  pageSize: 10,
};
const CriteriaApprovalList = () => {

  const navigate = useNavigate();
  const molGridRef = useRef();
  const CriteriaApprovalRef = useRef();
  const [dataSource, setDataSource] = useState([]);
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 10,
    CriteriaName: null,
    ChannelId: null,
    StatusId: null,
  });
  const [formData, setFormData] = useState(CriteriaApprovalData);
  const [getDropdowns, { data: dropdownData, isLoading: dropdownLoading }] = useLazyGetAllDropdownForCRUDCategoryQuery();
  const [getApprovalCriteriaList, { data: criteriaListData, isLoading: criteriaLoading },] = useGetAllCriteriaListForApprovalMutation();

  const companies = [
    {
      id: 1,
      channel: "Products",
      criteriaName: "Acoustic Ceiling Board 20250604",
      status: "Submitted",
    },
    {
      id: 2,
      channel: "Products",
      criteriaName: "Acoustic Ceiling Board 20250604",
      status: "Approved",
    },
    {
      id: 3,
      channel: "Products",
      criteriaName: "Acoustic Ceiling Board 20250604",
      status: "Approved",
    },
    {
      id: 4,
      channel: "Products",
      criteriaName: "Acoustic Ceiling Board 20250604",
      status: "Approved",
    },
    {
      id: 5,
      channel: "Products",
      criteriaName: "Acoustic Ceiling Board 20250604",
      status: "Approved",
    },
    {
      id: 6,
      channel: "Products",
      criteriaName: "Acoustic Ceiling Board 20250604",
      status: "Approved",
    },
    {
      id: 7,
      channel: "Services",
      criteriaName: "Acoustic Ceiling Board 20250604",
      status: "Approved",
    },
    {
      id: 8,
      channel: "Services",
      criteriaName: "Acoustic Ceiling Board 20250604",
      status: "Approved",
    },
    {
      id: 9,
      channel: "Services",
      criteriaName: "Acoustic Ceiling Board 20250604",
      status: "Submitted",
    },
  ];

  useEffect(() => {
    getDropdowns();
    getApprovalCriteriaList(paginationRequest);
  }, []);

  useEffect(() => {
    if (!dropdownLoading && dropdownData) {
      setAllDropDownField(dropdownData);
    }
  }, [dropdownLoading, dropdownData]);

  useEffect(() => {
    if (!criteriaLoading && criteriaListData) {
      setDataSource(criteriaListData?.itemList || []);
      setPaginationRequest((prev) => ({ ...prev, totalCount: criteriaListData?.totalCount, }));
    }
  }, [criteriaLoading, criteriaListData]);

  const handleViewClick = (data) => {
    navigate(`/approveCriteria/${encryptAESID(data?.sgbpCriteriaId)}`);
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getApprovalCriteriaList(updatedPaginationRequest);
  };

  const handleSearch = () => {
    const formValues = CriteriaApprovalRef.current?.getFormData();
    if (!formValues) return;

    const request = {
      pageNo: 1,
      pageSize: 20,
      CriteriaName: formValues?.searchByCriteriaName || null,
      ChannelId: formValues?.channel?.value || formValues?.channel || null,
      StatusId: formValues?.statusId?.value || formValues?.statusId || null,
    };

    setPaginationRequest(request);
    getApprovalCriteriaList(request);
  };

  const handleClearClick = () => {
    const clearedForm = {
      ...CriteriaApprovalData,
      initialState: {
        requirementName: null,
        channel: null,
        statusId: null,
      },
    };
    let req = {
      ...paginationRequest,
      CriteriaName: null,
      ChannelId: null,
      StatusId: null,
    }
    setFormData(clearedForm);
    setPaginationRequest(req);
    getApprovalCriteriaList(req);
  };



  const actionHandler = {
    VIEW: handleViewClick,
    ACTIVATE: handleViewClick,
    DEACTIVATE: handleViewClick,
  };

  return (
    <div className="crud-requirement-list">
      <div className="corporate-member-list">
        <div className="sgbp-category">
          <div className="row status-input pr-0">
            <FormCreator ref={CriteriaApprovalRef} {...formData} />
            <div className="col-4 d-flex align-items-end mt-4 gap-3">
              <Buttons
                buttonText="Search"
                buttonTypeClassName="search-btn "
                onClick={handleSearch}
              />
              <Buttons
                buttonText="Clear"
                buttonTypeClassName="btn btn-secondary"
                onClick={handleClearClick}
              />
            </div>
          </div>
          {/* <div className="add-btn-sec mt-4 pr-0">
            <Buttons
              buttonText="+ Add New"
              buttonTypeClassName="add-btn"
              // onClick={handleAddRow}
            />
          </div> */}
        </div>

        <div className="member-list">
          <MolGrid
            ref={molGridRef}
            configuration={CriteriaApprovalConfig}
            dataSource={dataSource}
            allowPagination={true}
            pagination={paginationRequest}
            onPageChange={handlePageChange}
            onActionChange={actionHandler}
            isLoading={criteriaLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default CriteriaApprovalList;
